import React, { useEffect, useState } from "react";
import axios from "axios";
import AuthService from "../utils/auth.service";
import BlogAdmin from "./BlogAdmin";

const API = "https://bbest.dev:7500";

export default function AdminDashboard() {
  const [section, setSection] = useState(window.location.pathname === "/blog" ? "blog" : "projects");
  const [projects, setProjects] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [selected, setSelected] = useState(null);
  const [form, setForm] = useState({ title: "", image: "", description: "", repository: "", demo: "" });
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  const load = async () => {
    setLoading(true);
    try {
      const result = await Promise.all([
        axios.get(API + "/projects/all"),
        axios.get(API + "/user-api/get-questions")
      ]);
      setProjects(result[0].data || []);
      setQuestions(result[1].data || []);
    } finally { setLoading(false); }
  };

  useEffect(() => { load().catch(() => setMessage("Unable to connect to the API.")); }, []);

  const choose = (item) => {
    setSelected(item);
    setForm({
      title: item.title || "", image: item.image || "", description: item.description || "",
      repository: item.repository || "", demo: item.demo || ""
    });
  };
  const reset = () => {
    setSelected(null);
    setForm({ title: "", image: "", description: "", repository: "", demo: "" });
  };
  const save = async (event) => {
    event.preventDefault();
    if (selected) await axios.put(API + "/projects/update", { ...form, _id: selected._id });
    else await axios.post(API + "/projects/post", form);
    await load();
    reset();
    setMessage(selected ? "Project updated." : "Project published.");
  };
  const remove = async () => {
    if (!selected || !window.confirm("Delete this project?")) return;
    await axios.put(API + "/projects/delete", { title: selected.title });
    await load();
    reset();
    setMessage("Project deleted.");
  };

  const user = AuthService.getCurrentUser();
  if (!user || !user.roles || !user.roles.includes("ROLE_ADMIN")) {
    return <main className="admin-locked"><h1>Admin access required</h1><a href="/login">Go to login</a></main>;
  }

  return <main className="cms-shell">
    <aside className="cms-sidebar">
      <div className="cms-logo"><span>B</span><div><strong>bbest.dev</strong><small>Admin workspace</small></div></div>
      <div className="cms-label">Workspace</div>
      <nav className="cms-nav">
        <button className={section === "projects" ? "active" : ""} onClick={() => setSection("projects")}><span>▦</span>Projects<i>{projects.length}</i></button>
        <button className={section === "questions" ? "active" : ""} onClick={() => setSection("questions")}><span>◌</span>Questions<i>{questions.filter((q) => !q.response).length}</i></button>
        <button className={section === "blog" ? "active" : ""} onClick={() => setSection("blog")}><span>✦</span>Blog posts</button>
      </nav>
      <div className="cms-sidebar-bottom"><div className="cms-user"><b>{user.username.charAt(0).toUpperCase()}</b><span>{user.username}<small>Administrator</small></span></div><button onClick={() => { AuthService.logout(); window.location.href = "/login"; }}>Sign out</button></div>
    </aside>
    <section className="cms-workspace">
      <header className="cms-header"><div><small>CONTENT / {section.toUpperCase()}</small><h1>{section === "projects" ? "Projects" : section === "questions" ? "Questions" : "Blog posts"}</h1></div><button className="cms-refresh" onClick={load}>Refresh</button></header>
      {message && <div className="cms-message">{message}<button onClick={() => setMessage("")}>×</button></div>}
      {loading ? <div className="cms-empty">Loading…</div> : section === "projects" ? <Projects projects={projects} selected={selected} form={form} setForm={setForm} choose={choose} reset={reset} save={save} remove={remove} /> : section === "questions" ? <Questions questions={questions} /> : <BlogAdmin />}
    </section>
  </main>;
}

function Projects({ projects, selected, form, setForm, choose, reset, save, remove }) {
  return <div className="cms-projects"><section className="cms-list-panel"><div className="cms-panel-head"><div><small>PORTFOLIO</small><h2>All projects</h2></div><button className="cms-primary" onClick={reset}>+ New project</button></div><div className="cms-search"><input placeholder="Search projects" onChange={(e) => {}} /></div><div className="cms-items">{projects.map((item) => <button className={selected && selected._id === item._id ? "cms-item selected" : "cms-item"} key={item._id || item.title} onClick={() => choose(item)}><span style={item.image ? { backgroundImage: "url(" + item.image + ")" } : {}}>✦</span><div><strong>{item.title}</strong><small>{item.description}</small></div><b>›</b></button>)}</div></section><section className="cms-editor"><div className="cms-panel-head"><div><small>{selected ? "EDIT PROJECT" : "CREATE PROJECT"}</small><h2>{selected ? "Edit project" : "New project"}</h2></div>{selected && <button className="cms-delete" onClick={remove}>Delete</button>}</div><form onSubmit={save}><label>Project name<input required value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} /></label><label>Image URL<input value={form.image} onChange={(e) => setForm({ ...form, image: e.target.value })} /></label><label>Description<textarea required rows="6" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} /></label><label>Repository URL<input value={form.repository} onChange={(e) => setForm({ ...form, repository: e.target.value })} /></label><label>Live preview URL<input value={form.demo} onChange={(e) => setForm({ ...form, demo: e.target.value })} /></label><button className="cms-primary" type="submit">{selected ? "Save changes" : "Publish project"}</button></form></section></div>;
}

function Questions({ questions }) {
  return <div className="cms-question-list"><div className="cms-panel-head"><div><small>INBOX</small><h2>Visitor questions</h2></div><span className="cms-count">{questions.length} total</span></div>{questions.map((question) => <article className="cms-question" key={question._id}><div><span className={question.response ? "answered" : "waiting"}>{question.response ? "Answered" : "Needs reply"}</span><h3>{question.question}</h3><small>{question.email || "Visitor inquiry"}</small></div><button>Open ›</button></article>)}</div>;
}
